import { useParams } from 'react-router-dom';

import { NotFound } from '@/components/molecules/NotFound';
import { parsePositiveInt } from '@/utils/parsePositiveInt';

import ClientContainer from './ClientContainer';

/** `/internal/clients/:clientId`: an id that cannot be a client is not found, unasked. */
export default function ClientRoute() {
    const clientId = parsePositiveInt(useParams().clientId);

    if (clientId === null) {
        return <NotFound />;
    }
    return <ClientContainer clientId={clientId} />;
}
